import { FC, useContext } from "react";
import styled from "styled-components";
import { StarIcon } from "../Icons";
import ThemeContext from "../../themes/context";

const StarIndicatorWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: flex-start;
	align-items: center;
	align-content: center;
	padding-bottom: 10px;
	gap: 3px;
	color: ${props => (props.theme.colors.yellowVitat || "#6a4caf")};
`;

const ReviewQuantidadWrapper = styled.span`
	margin: 0px;
	font-family: Livvic;
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	padding-top: 5px;
`;

interface StarIndicatorProps {
	grade: number;
	maxGrade: number;
	reviewsQuantidade?: number;
	callbackFn?: (star: number) => void;
	handleTotalReviewsClick?: () => void;
}

const StarIndicator: FC<StarIndicatorProps> = ({ grade, maxGrade, reviewsQuantidade, callbackFn, handleTotalReviewsClick }) => {
	const theme = useContext(ThemeContext);

	const getStarsArray = () => {
		const arr: boolean[] = [];
		for (let i = 0; i < maxGrade; i++) {
			arr.push(grade - 1 >= i);
		}
		return arr;
	};

	const handleRenderStars = (checked: boolean) => {
		if (checked) {
			return <StarIcon size={14} color={theme.colors.yellowVitat || "6A4CAF"} />;
		}
		return <StarIcon size={14} color="#D1D1D1" />;
	};

	return (
		<StarIndicatorWrapper>
			{getStarsArray().map((checked: boolean, index: number) => (
				<div onClick={callbackFn ? () => callbackFn(index + 1) : () => {}} key={index}>
					{handleRenderStars(checked)}
				</div>
			))}
			{reviewsQuantidade !== undefined && (
				<ReviewQuantidadWrapper onClick={handleTotalReviewsClick}>{`(${reviewsQuantidade})`}</ReviewQuantidadWrapper>
			)}
		</StarIndicatorWrapper>
	);
};

export default StarIndicator;
